import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import {
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import { Typography } from '@mui/material';
import clsx from 'clsx';
import CreateIcon from '@mui/icons-material/Create';

const PREFIX = 'ExparienceLogo';

const classes = {
  fullWidthElement: `${PREFIX}-fullWidthElement`,
  paddingRoot: `${PREFIX}-paddingRoot`,
  marginTop: `${PREFIX}-marginTop`,
  title: `${PREFIX}-title`,
  subTitle: `${PREFIX}-subTitle`,
  contentContainer: `${PREFIX}-contentContainer`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  actionButton: `${PREFIX}-actionButton`,
  imageContainer: `${PREFIX}-imageContainer`,
  paintingContainer: `${PREFIX}-paintingContainer`,
  editImageIcon: `${PREFIX}-editImageIcon`,
  divider: `${PREFIX}-divider`,
  watermarkImage: `${PREFIX}-watermarkImage`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.fullWidthElement}`]: {
    width: '100%',
    textAlign: 'center',
    paddingTop: '1rem',
  },

  [`& .${classes.paddingRoot}`]: {
    padding: '1rem',
  },

  [`& .${classes.marginTop}`]: {
    marginTop: '1rem !important',
  },

  [`& .${classes.title}`]: {
    marginBottom: '0.5rem !important',
  },

  [`& .${classes.subTitle}`]: {
    marginBottom: '1.5rem !important'
  },

  [`& .${classes.contentContainer}`]: {
    [theme.breakpoints.up('sm')]: {
      width: '80%',
    },
    margin: '0 auto'
  },

  [`& .${classes.buttonContainer}`]: {
    display: 'flex',
    justifyContent: 'end',
    [theme.breakpoints.up('sm')]: {
      width: '90%',
    },
  },

  [`& .${classes.actionButton}`]: {
    float: 'right',
  },

  [`& .${classes.imageContainer}`]: {
    position: 'relative',
    maxWidth: '370px',
    margin: '0 auto',
  },

  [`& .${classes.paintingContainer}`]: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '1rem',
    minWidth: '50%',
    maxWidth: '50%',
    [theme.breakpoints.between('xs', 'md')]: {
      flexDirection: 'column',
      minWidth: '100%',
      maxWidth: '100%'
    },
  },

  [`& .${classes.editImageIcon}`]: {
    position: 'absolute',
    right: '0',
    top: '0',
  },

  [`& .${classes.divider}`]: {
    // marginTop: '2rem',
    // marginBottom: '2rem',
  },

  [`& .${classes.watermarkImage}`]: {
    maxWidth: '370px',
    borderRadius: '10px',
  }
}));

export const ExparienceLogo = (props) => {

  const { t } = useTranslation();
  const [urls, setUrls] = useState({})

  function handleImageReader(event, id) {
    let tmp = { ...urls };
    tmp[id] = URL.createObjectURL(event.target.files[0])
    setUrls(tmp);
  }

  if (props.currentStep >= 1) {
    return (
      <Root>
        <div className={clsx(classes.fullWidthElement, classes.paddingRoot)}>
          <Typography variant="h5" className={classes.title}>{t('exparienceCreateForm.exparienceLogoTitle')}</Typography>
          <Typography variant="body2" className={classes.subTitle}>{t('exparienceCreateForm.exparienceLogoSubTitle')}</Typography>
          <div className={classes.contentContainer}>
            <div className={classes.imageContainer}>
              <div className={classes.paintingContainer}>
                <img
                  id="exparienceLogo"
                  className={classes.watermarkImage}
                  alt={(urls.exparienceLogo && urls.exparienceLogo) || (props.exparience && props.exparience.logoUrl) ? "exparience logo" : null}
                  src={(urls.exparienceLogo ? urls.exparienceLogo : undefined) || (props.exparience ? props.exparience.logoUrl : undefined)}
                />
                {!(urls.exparienceLogo || (props.exparience && props.exparience.logoUrl)) &&
                  <div>
                    <input
                      type="file"
                      accept="image/*"
                      name="exparienceLogo"
                      id="icon-button-exparience-logo-add"
                      style={{ display: 'none' }}
                      onChange={e => {
                        handleImageReader(e, 'exparienceLogo');
                        props.setFiles({ ...props.files, exparienceLogo: e.target.files });
                        props.handleChangeField('logo', e.target.files[0].name);
                      }}
                    />
                    <label htmlFor="icon-button-exparience-logo-add">
                      <Button
                        variant="contained"
                        color="primary"
                        component="span"
                      >
                        {t('myDesign.zones.uploadVideo.selectFileButton')}
                      </Button>
                    </label>
                  </div>
                }
                {(urls.exparienceLogo || (props.exparience && props.exparience.logoUrl)) &&
                  <div className={classes.editImageIcon}>
                    <input
                      type="file"
                      accept="image/*"
                      name="exparienceLogoModify"
                      id="icon-button-file"
                      style={{ display: 'none' }}
                      onChange={(e) => {
                        handleImageReader(e, 'exparienceLogo');
                        props.setFiles({ ...props.files, exparienceLogo: e.target.files });
                        props.handleChangeField('logo', e.target.files[0].name);
                      }}
                    />
                    <label htmlFor="icon-button-file">
                      <IconButton
                        color="primary"
                        aria-label="upload picture"
                        component="span"
                        onClick={(e) => {
                          e.stopPropagation();
                        }}
                        size="large">
                        <CreateIcon />
                      </IconButton>
                    </label>
                  </div>
                }
              </div>
            </div>
            {props.currentStep === 1 &&
              <div className={classes.buttonContainer}>
                <Button
                  variant="contained"
                  color="primary"
                  disabled={!props.files.exparienceLogo}
                  onClick={e => props.handleNextStep(2)}
                  className={classes.actionButton}
                >
                  {t('exparienceCreateForm.continueButton')}
                </Button>
              </div>
            }
          </div>
        </div>
        <Divider light className={classes.divider} />
      </Root>
    );
  } else {
    return null;
  }

}

export default ExparienceLogo